<template>

    <tbody>
        <tr :style="cssVars" :class="line_color">

            <td v-if="mode=='query'">{{ interaction.rank+1 }}</td>
            <td>
                <a  :href="taxon_link(interaction.taxon1.concept_id)" target="_blank">
                {{ interaction.taxon1.preferred_term }}
                </a>
            </td>
            <td v-if="interaction.interaction.concept_id != null">{{ interaction.interaction.preferred_term }}</td>
            <td v-else>Unknown</td>
            <td>
                <a :href="taxon_link(interaction.taxon2.concept_id)" target="_blank">
                    {{ interaction.taxon2.preferred_term }} 
                </a>
            </td>
            <td>{{ interaction.score.toFixed(2) }}</td>
            <td>{{ interaction.passages_count }}</td>
            <td>{{ interaction.docs_count }}</td>
            <td>
                <button @click="toggle()" class="button-table">
                    <img v-if="!expanded" src="../assets/images/icon_expand.png"  class="mini"/>
                    <img v-if="expanded" src="../assets/images/icon_reduce.png"  class="mini"/>
               </button>
            </td>

        </tr>

        <tr class="expanded" v-show="expanded">
            <td v-if="mode=='query'"></td>
            <td colspan="6">              
                <div v-if="in_progress" class="progress-container">
                    <PulseLoader :color="theme_color.main"/>
                </div>
                <div v-else>
                    <a class="link-container" v-if="mode=='fetch'" target="_blank" :href="biotic_search">Search for this interaction in other documents</a> &nbsp;  
                    <a class="link-container" target="_blank" :href="sibils_search">Search for this interaction in Biodiversity PMC</a>   <br/> <br/>
                    <p v-if="mode != 'fetch'">{{ documents.passages_count }} passage<span v-if="documents.passages_count > 1">s</span> in {{ documents.docs_count }} document<span v-if="documents.docs_count > 1">s</span></p>
                    <ResultsPassage v-for="document in documents.documents" :key="interaction.triplet_key+'-'+document.doc_id" :document="document" :collection_name="collection_name" :mode="mode"/>
                </div>
                

                <br/>
            </td>
            <td></td>
        </tr>

    </tbody>

</template>


<script>
import { mapState } from 'vuex'
import ResultsPassage from '@/components/ResultsPassage.vue'
var PulseLoader = require('vue-spinner/src/PulseLoader.vue').default;
import axios from 'axios';

    export default {
      name: 'InteractionElement',
      components: {
        ResultsPassage,
        PulseLoader
      },
      props: {
        interaction: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        collection_name: {
            type: String,
            required: true
        },
        mode: {
            type: String,
            required: true
        },
        
      },
      data() {
        return {
            expanded: false,
            length: 200,
            documents: null,
            in_progress: true
        };
      },
      computed: {
        ...mapState(['user_query', 'theme_color', 'urls']),
        cssVars () {
            return{
                '--color': this.theme_color.main,
            }
        },
        line_color(){
            if(this.index % 2 == 0){
                return "even"
            }
            else {
                return "odd"
            }
        },
        
        biotic_search(){
            var url = this.urls.gui
            if (process.env.NODE_ENV != 'production'){
                url = window.location.origin
            }
            var query = url+"?taxon1="+this.interaction.taxon1.preferred_term
            query += "&taxon2="+this.interaction.taxon2.preferred_term
            if (this.interaction.interaction.preferred_term != "none"){
                query += "&interaction="+this.interaction.interaction.concept_id
            }
            return query
        },
        sibils_search(){
            var query = "https://biodiversitypmc.sibils.org?query="+this.interaction.taxon1.preferred_term
            if (this.interaction.preferred_term != undefined){
                query += " AND "+this.interaction.preferred_term
            }
            query += " AND "+this.interaction.taxon2.preferred_term
            return query
        },
      },
      methods:{
        toggle (){
            if (this.expanded == false){
                this.$matomo?.trackEvent("Expand passage position for "+this.collection_name, "index"+this.index);
                this.$matomo?.trackEvent("Expand passage ", this.collection_name+":"+this.index+";"+this.interaction.taxon1.concept_id+";"+this.interaction.taxon2.concept_id+";"+this.interaction.interaction.concept_id);
            }
            this.expanded = !this.expanded
            if (this.mode != "fetch" && this.documents == null){
                this.load()
            }
            else if (this.mode == "fetch"){
                var output = {}
                output["passages_count"] = this.interaction["passages_count"]
                output["documents"] = [{"passages": this.interaction["passages"]}]
                this.documents = output
                this.in_progress = false
            }
        },
        load(){
            this.in_progress = true
            var url_passages = this.urls.passages
            var url = url_passages+"?collection="+this.collection_name+"&triplet_key="+encodeURIComponent(this.interaction.triplet_key)+"&gui"
            axios
                .get(url)
                .then(response => {
                    this.documents = response.data
                })
                .catch(error => {
                alert ("Failed to get passages: "+error)
                })
                .finally(() => this.in_progress = false)
        },
        taxon_link(code){
            if (code.includes("ott")){
                code = code.replace("ott:", "")
                return "https://tree.opentreeoflife.org/opentree/argus/opentree15.1@ott"+code
            }
            else if (code.includes("ncbi")){
                code = code.replace("ncbitaxon_viruses:", "")
                return "https://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?id="+code
            }
            else if (code.includes("ictv_subset")){
                code = code.replace("ictv_subset:", "")
                return "https://ictv.global/taxonomy/taxondetails?taxnode_id="+code
            }
        },
      },
      watch: {
        'interaction': function(){
            this.expanded = false
            this.in_progress = true
            this.documents = null
        },
      },
    }

</script>


<style scoped lang="scss">

    .mini {
        width: 15px;
    }

    .button-table {
      display: inline-block;
      border-radius:5px;
      background-color: #AAA;
      border: none;
      color: #FFFFFF;
      text-align: center;
      padding: 5px 5px;
      cursor: pointer;
    }

    .button-table:hover {
      background-color: var(--color);
    }
    td {
      border-bottom: 1px solid #ddd;
      padding: 6px;
      text-align: center;
    }
    .even {
          background-color: #fff;
      }

    .odd {
          background-color: #eee;
      }

      .even:hover {
          background-color: #ddd;
      }
      .odd:hover {
          background-color: #ddd;
      }



</style>
